export enum AttendanceStatusEnum {
  PRESENT = "PRESENT",
  ABSENT = "ABSENT",
  LATE = "LATE",
  HALF_DAY = "HALF_DAY",
}

export enum AttendanceStatusNameEnum {
  PRESENT = "Present",
  ABSENT = "Absent",
  LATE = "Late",
  HALF_DAY = "Half Day",
}

export interface AttendanceStatusItem {
  id: string;
  code: AttendanceStatusEnum | string;
  name: string;
  color: string;
  sort_order: number;
  is_active: number;
}

export interface EmployeeShift {
  id: string;
  name: string;
  start_time: string;
  end_time: string;
  break_minutes: number;
  standard_hours: number;
  is_active?: number;
  created_at?: string;
}

export interface ShiftAssignment {
  id: string;
  employee_id: string;
  shift_id: string;
  effective_from: string;
  effective_to?: string | null;
  notes?: string;
  shift_name?: string;
  start_time?: string;
  end_time?: string;
  standard_hours?: number;
  first_name?: string;
  last_name?: string;
  designation?: string;
  created_at?: string;
}

export interface TenantPayrollPolicy {
  working_days_per_month: number;
  monthly_work_hours: number;
  ot_multiplier: number;
  att_allowance_mode: string;
  att_max_absent_allowed: number;
  att_deduction_per_absent: number;
  default_epf_rate: number;
  default_epf_employer_rate: number;
  default_etf_rate: number;
  default_work_start_time?: string;
  default_work_end_time?: string;
  standard_working_hours?: number;
}

